const Title = ({ title }: { title: string }) => (
  <p className={`mb-3 text-center text-xl font-bold uppercase text-teal-600`}>{title}</p>
)

export default Title
